module.exports = __webpack_public_path__ + "img/explain.f37b2a88.svg";